import React from "react";
import "./page-skeleton.scss";

/**
 * Generic detail/settings page placeholder — header plus stacked content blocks.
 */
const PageContentSkeleton = ({
  titleWidth = "200px",
  showHeader = true,
  blocks = 2,
  className = "",
}) => (
  <div
    className={`page-skeleton page-content-skeleton ${className}`.trim()}
    aria-busy="true"
    aria-live="polite"
  >
    {showHeader && (
      <div className="page-skeleton-header">
        <span
          className="page-skel page-skel-title"
          style={{ width: titleWidth, display: "block" }}
        />
      </div>
    )}
    <div className="page-skeleton-cards">
      {Array.from({ length: blocks }).map((_, i) => (
        <div className="page-skeleton-card" key={`block-${i}`}>
          <span className="page-skel page-skel-block" />
          <span className="page-skel page-skel-block short" />
          <span className="page-skel page-skel-block tall" />
        </div>
      ))}
    </div>
  </div>
);

export default PageContentSkeleton;
